import AIHistoryItem from 'components/AIHistoryItem'
import { IAIVideoProject } from 'types/aiVideo'
import VideoItem from '../VideoItem'
import { memo } from 'react'

import { useAiVideoItemTagsData } from '../../hooks/useAiVideoItemTagsData'

interface IHistoryListProps {
  historyItems: IAIVideoProject[]
}

const HistoryList = ({ historyItems }: IHistoryListProps) => {
  const getItemTags = useAiVideoItemTagsData()
  return (
    <>
      {historyItems.map(video => {
        const { prompt, id, videoModel } = video
        const tags = getItemTags(video.quality, videoModel)

        return (
          <AIHistoryItem
            key={id}
            prompt={prompt}
            tags={tags}
            content={<VideoItem {...video} />}
          />
        )
      })}
    </>
  )
}

export default memo(HistoryList)
